<div
  class="border-top pt-4"
  *ngIf="isReserveAuthEnabled">
  <mbs-switcher
    [subtitleOutside]="false"
    [subtitle]="'shared:reserveAuth.reserveAuthorizationMethodHint' | i18next"
    [label]="'shared:reserveAuth.reserveAuthorizationMethod' | i18next"
    [formControl]="isReserveAuthOpenedControl"
    class="text-base"></mbs-switcher>
  <mbs-accordion
    [withoutBorder]="true"
    [isDefaultView]="false"
    [isTitlePrimary]="false"
    [activeIds]="isReserveAuthOpenedControl.value ? 'panel' : null"
    [arrow]="false">
    <mbs-accordion-panel
      [id]="'panel'"
      [hideHeader]="true">
      <mbs-reserve-auth-add
        (confirmed)="confirmed.emit()"
        [authId]="authId"></mbs-reserve-auth-add>
    </mbs-accordion-panel>
  </mbs-accordion>
</div>
